import { PayPerLeadSubscription, StateIdType, SubscriptionStateItem } from "@containers/PayPerLead/interface";

export const MIN_LEAD_COUNT = 5;
export const MIN_STATEWIDE_LEAD_COUNT = 20;
export const MIN_NATIONWIDE_LEAD_COUNT = 30;
export const MIN_TOTAL_LEAD_COUNT = 10;
export const MAX_LEAD_COUNT = 500;

export const isDuplicate = (item: SubscriptionStateItem, subscriptions?: PayPerLeadSubscription[]): boolean => {
  const checkItemAllCounties = (item: SubscriptionStateItem): boolean => {
    return !!subscriptions?.some((subscription) =>
      subscription?.items?.some(
        (subItem) => subItem.state_id === item.state_id && subItem.all_counties && subscription.is_active,
      ),
    );
  };

  const checkItemCounty = (item: SubscriptionStateItem, countyId: number): boolean => {
    return !!subscriptions?.some((subscription) =>
      subscription?.items?.some(
        (subItem) =>
          subItem.state_id === item.state_id &&
          !subItem.all_counties &&
          subItem?.counties?.some((subCounty) => subCounty.county_id === countyId) &&
          subscription.is_active,
      ),
    );
  };

  const checkItemCounties = (item: SubscriptionStateItem): boolean => {
    return item.counties?.some((county) => checkItemCounty(item, county.county_id));
  };

  if (item.all_counties) {
    return checkItemAllCounties(item);
  } else {
    return checkItemCounties(item);
  }
};

export const isStateItemValid = (item: SubscriptionStateItem): boolean => {
  if (!item.state_id) {
    return false;
  }

  if (item.isDuplicate) {
    return false;
  }

  if (item.state_id === StateIdType.Nationwide && !isValidNationwideLeadsCount(item.leads_total)) {
    return false;
  }

  if (item.all_counties && !isValidStatewideLeadsCount(item.leads_total)) {
    return false;
  }

  if (item.all_counties || item.state_id === StateIdType.Nationwide) {
    return isValidLeadsCount(item.leads_total);
  } else {
    if (item.counties.length === 0) {
      return false;
    }

    if (item.force_total_per_county) {
      return item.counties.every((item) => isValidLeadsCount(item.total_leads));
    } else {
      return isValidLeadsCount(item.leads_total);
    }
  }
};

export const isNationWide = (s: PayPerLeadSubscription) => {
  return s.items.some((i) => i.state_id === StateIdType.Nationwide);
};

export const hasAllCounties = (s: PayPerLeadSubscription) => {
  return s.items.some((i) => i.all_counties);
};

export const isValidLeadsCount = (total?: number) => {
  return !!(total && total >= MIN_LEAD_COUNT && total <= MAX_LEAD_COUNT);
};

export const isValidNationwideLeadsCount = (total?: number) => {
  return total && total >= MIN_NATIONWIDE_LEAD_COUNT && total <= MAX_LEAD_COUNT;
};

export const isValidStatewideLeadsCount = (total?: number) => {
  return total && total >= MIN_STATEWIDE_LEAD_COUNT && total <= MAX_LEAD_COUNT;
};

export const hasCoverageValidationError = (subscription: PayPerLeadSubscription): boolean => {
  return !(isNationWide(subscription) || hasAllCounties(subscription));
};
